package com.eladfinish.bible.contest.screens.browse.tableOfContents.model

data class BookmarkData(
    val browseMode: BrowseMode,
    val bookIndex: Int,
    val partIndex: Int,
    val bookmarkScrollY: Int,
    val bookmarkTextOffset: Int = -1,
    val showOnqelos: Boolean,
)
